import React, { useState, useEffect } from 'react';
import { 
  FaTruck, 
  FaCar, 
  FaUserTie, 
  FaChartBar, 
  FaMoneyBill, 
  FaClipboard, 
  FaMoneyCheckAlt, 
  FaCloudUploadAlt,
  FaRegCalendarAlt
} from 'react-icons/fa';
import { BiEditAlt } from 'react-icons/bi';

import './Sidebar.css';
import '../../Pages/HomePage/HomePage.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { useAuth } from '../../Auth/AuthContext';

const Sidebar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [path,setPath] = useState('');

    const { userProfile, moduleChange, setModuleChange,activeModule,setActiveModule } = useAuth();

    useEffect(() => {
        
      console.log('UseEffect called');

      if(moduleChange){
          sessionStorage.setItem('actMod', "upload");
          setActiveModule('upload');
          setModuleChange('');
      }
  }, [moduleChange]);

    const handleNavigation = (module,path) => {
        // Restrict access based on userProfile
        console.log('User Profile:', userProfile);
        const restrictedModules = {
            loadingManager: ['freight','reports', 'business','transactions', 'generate-bill', 'revise-bill'],
            unloadingManager: ['freight','business', 'vehicle', 'vendor', 'transactions', 'generate-bill', 'revise-bill'],
        };

        if (restrictedModules[userProfile]?.includes(module)) {
            console.log('You do not have access to this section.');
            alert('You do not have access to this section.');
            return;
        }
        
        // sessionStorage.setItem('actMod', module);
        // setActiveModule(module); // Set the active module
        navigate(path);
    };

    return (
        <aside className="sidebar">
            <ul className="sidebar-menu">
                <li
                    className={`sidebar-item ${activeModule === 'upload' ? 'active' : ''}`}
                    onClick={() => handleNavigation('upload','/home')}
                >
                    <FaCloudUploadAlt className="icon" />
                    <span>Upload Trip Details</span>
                </li>
                <li
                    className={`sidebar-item ${activeModule === 'today-list' ? 'active' : ''}`}
                    onClick={() => handleNavigation('today-list','/today-list')}
                >
                    <FaRegCalendarAlt className="icon" />
                    <span>Today's List</span>
                </li>
                <li
                    className={`sidebar-item freight ${activeModule === 'freight' ? 'active' : ''}`}
                    onClick={() => handleNavigation('freight','/freight')}
                >
                    <FaTruck className="icon" />
                    <span>Freight</span>
                </li>
                <li
                    className={`sidebar-item vehicle ${activeModule === 'vehicle' ? 'active' : ''}`}
                    onClick={() => handleNavigation('vehicle','/vehicle')}
                >
                    <FaCar className="icon" />
                    <span>Vehicle</span>
                </li>
                <li
                    className={`sidebar-item vendor ${activeModule === 'vendor' ? 'active' : ''}`}
                    onClick={() => handleNavigation('vendor','/vendor')}
                >
                    <FaUserTie className="icon" />
                    <span>Vendor</span>
                </li>
                <li
                    className={`sidebar-item repo ${activeModule === 'reports' ? 'active' : ''}`}
                    onClick={() => handleNavigation('reports','/reports')}
                >
                    <FaChartBar className="icon" />
                    <span>Reports</span>
                </li>
                <li
                    className={`sidebar-item bill ${activeModule === 'generate-bill' ? 'active' : ''}`}
                    onClick={() => handleNavigation('generate-bill','/generate-bill')}
                >
                    <FaMoneyBill className="icon" />
                    <span>Billing</span>
                </li>
                <li
                    className={`sidebar-item transactions ${activeModule === 'transactions' ? 'active' : ''}`}
                    onClick={() => handleNavigation('transactions','/transactions')}
                >
                    <FaMoneyCheckAlt className="icon" />
                    <span>Transactions</span>
                </li>
                <li
                    className={`sidebar-item business ${activeModule === 'business' ? 'active' : ''}`}
                    onClick={() => handleNavigation('business','/business')}
                >
                    <FaClipboard className="icon" />
                    <span>Business</span>
                </li>
                <li
                    className={`sidebar-item revise-bill ${activeModule === 'revise-bill' ? 'active' : ''}`}
                    onClick={() => handleNavigation(`revise-bill`,'/revise-bill')}
                >
                    <BiEditAlt className="icon" />
                    <span>Revise Bill</span>
                </li>
            </ul>
        </aside>
    );
};

export default Sidebar;